/*
  A pause button for every video that plays by itself.

  The theme's background videos autoplay, muted and looping, with no controls.
  WCAG 2.2.2 (Pause, Stop, Hide) needs a way to stop anything that moves on its
  own for more than five seconds, so each such video gets a small toggle in its
  corner. Visitors who ask their device to reduce motion get the videos paused
  from the start, with the same button to play them.

  The videos are inserted late (the theme swaps them in from templates as they
  scroll into view), so this listens for "play" at the document rather than
  looking for videos once at load.
*/
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var PAUSE = '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" focusable="false"><path fill="currentColor" d="M7 5h3.5v14H7zM13.5 5H17v14h-3.5z"/></svg>';
  var PLAY = '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" focusable="false"><path fill="currentColor" d="M8 5.5v13l10.5-6.5z"/></svg>';

  var style = document.createElement('style');
  style.textContent =
    '.video-pause{position:absolute;inset-inline-end:12px;inset-block-end:12px;z-index:5;' +
    'display:flex;align-items:center;justify-content:center;width:40px;height:40px;padding:0;' +
    'border:0;border-radius:999px;background:rgba(18,30,42,.72);color:#fff;cursor:pointer}' +
    '.video-pause:hover{background:rgba(18,30,42,.9)}' +
    '.video-pause:focus-visible{outline:2px solid #fff;outline-offset:2px;box-shadow:0 0 0 4px rgba(18,30,42,.9)}';
  document.head.appendChild(style);

  // Only videos that move on their own: autoplaying, no native controls, and
  // either looping or long enough to matter.
  function needsToggle(v) {
    if (!(v instanceof HTMLVideoElement) || v.controls || v.dataset.pauseToggle) return false;
    if (!v.autoplay && !v.hasAttribute('autoplay')) return false;
    return v.loop || !(v.duration <= 5);
  }

  // Outside any link the video sits in, so the button isn't nested inside it.
  function hostFor(v) {
    var host = v.closest('.media') || v.parentElement;
    var link = host && host.closest('a');
    if (link) host = link.parentElement;
    if (host && getComputedStyle(host).position === 'static') host.style.position = 'relative';
    return host;
  }

  function sync(v, btn) {
    var paused = v.paused;
    btn.innerHTML = paused ? PLAY : PAUSE;
    btn.setAttribute('aria-label', paused ? 'Play background video' : 'Pause background video');
  }

  function attach(v) {
    if (!needsToggle(v)) return;
    var host = hostFor(v);
    if (!host) return;
    v.dataset.pauseToggle = '1';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'video-pause';
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (v.paused) { v.dataset.userChoice = 'play'; v.play().catch(function () {}); }
      else { v.dataset.userChoice = 'pause'; v.pause(); }
    });
    v.addEventListener('play', function () { sync(v, btn); });
    v.addEventListener('pause', function () { sync(v, btn); });
    host.appendChild(btn);
    sync(v, btn);
  }

  // The visitor's last choice wins; before they make one, reduced motion decides.
  function heldBack(v) {
    return v.dataset.userChoice ? v.dataset.userChoice === 'pause' : reduce.matches;
  }

  document.addEventListener('play', function (e) {
    var v = e.target;
    if (!(v instanceof HTMLVideoElement)) return;
    attach(v);
    // A video the visitor paused stays paused, even when the theme restarts it
    // on scrolling back into view; with reduced motion, nothing starts unasked.
    if (v.dataset.pauseToggle && heldBack(v)) v.pause();
  }, true);

  // Videos that are already in the page, playing or held back.
  function scan() {
    var vids = document.querySelectorAll('video[autoplay]');
    for (var i = 0; i < vids.length; i++) {
      attach(vids[i]);
      if (vids[i].dataset.pauseToggle && heldBack(vids[i])) vids[i].pause();
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
})();
